import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.official.receipt');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-official-receipt',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.official.receipt/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
}`],
})
export class PortalLpsysadminOfficialReceiptComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public loaded: boolean = false;
    public items: any[] = [];
    public users: any[] = [];
    public selected: any = null;
    public isEditing: boolean = false;
    public keyword: string = '';
    public filterCategory: string = '';
    public filterReplyType: string = '';
    public search: any = { page: 1 };
    public pagination: any = { start: -1, end: -1 };

    public categories: any[] = [
        { key: 'fund', label: '조합관련' },
        { key: 'company', label: '투자기업' },
        { key: 'support', label: '지원사업' },
        { key: 'tips', label: '팁스' },
        { key: 'other', label: '기타' }
    ];

    public replyTypes: any[] = [
        { key: 'required', label: '회신필요' },
        { key: 'not_required', label: '회신 불필요' }
    ];

    public async ngOnInit() {
        await this.service.init();
        await this.loadUsers();
        await this.load();
        this.newReceipt();
    }

    public async loadUsers() {
        const { code, data } = await wiz.call("users");
        if (code === 200) {
            this.users = data.rows || [];
        }
    }

    public today(): string {
        return new Date().toISOString().slice(0, 10);
    }

    public async load(page: number = 1) {
        this.search.page = page;
        this.loaded = false;
        await this.service.render();
        const { code, data } = await wiz.call("search", {
            page,
            keyword: this.keyword,
            category: this.filterCategory,
            reply_type: this.filterReplyType
        });
        if (code === 200) {
            this.items = data.rows || [];
            const startpage = Math.floor((page - 1) / 10) * 10 + 1;
            this.pagination.start = startpage;
            this.pagination.end = data.lastpage || 0;
        }
        this.loaded = true;
        await this.service.render();
    }

    public async applyFilter() {
        await this.load(1);
    }

    public newReceipt() {
        this.selected = {
            id: '',
            subject: '',
            category: 'fund',
            reply_type: 'not_required',
            received_date: this.today(),
            sender: '',
            document_no: '',
            content: '',
            attachments: [],
            viewer_ids: this.users.map((u: any) => u.id)
        };
        this.isEditing = true;
        this.service.render();
    }

    public async open(item: any) {
        const { code, data } = await wiz.call("get", { id: item.id });
        if (code === 200) {
            this.selected = data.item;
            if (!this.selected.viewer_ids) this.selected.viewer_ids = [];
            if (!this.selected.attachments) this.selected.attachments = [];
            this.isEditing = false;
            await this.service.render();
        }
    }

    public editSelected() {
        this.isEditing = true;
        this.service.render();
    }

    public categoryLabel(key: string): string {
        const item = this.categories.find((c: any) => c.key === key);
        return item ? item.label : key;
    }

    public replyLabel(key: string): string {
        const item = this.replyTypes.find((r: any) => r.key === key);
        return item ? item.label : key;
    }

    public replyClass(key: string): string {
        return key === 'required' ? 'bg-rose-50 text-rose-700' : 'bg-zinc-100 text-zinc-600';
    }

    public categoryClass(key: string): string {
        const map: any = {
            fund: 'bg-indigo-50 text-indigo-700',
            company: 'bg-blue-50 text-blue-700',
            support: 'bg-emerald-50 text-emerald-700',
            tips: 'bg-amber-50 text-amber-700',
            other: 'bg-zinc-100 text-zinc-600'
        };
        return map[key] || map.other;
    }

    public displayTitle(item: any): string {
        const subject = item?.subject || '';
        return `${this.categoryLabel(item?.category)} 동의서/공문접수${subject ? ' - ' + subject : ''}`;
    }

    public sharedNames(item: any): string {
        const ids = item?.viewer_ids || [];
        if (!ids.length) return '공유 대상 없음';
        const names = ids
            .map((id: string) => this.users.find((u: any) => u.id === id)?.name)
            .filter((name: string) => !!name);
        if (names.length <= 3) return names.join(', ');
        return `${names.slice(0, 3).join(', ')} 외 ${names.length - 3}명`;
    }

    public isShared(userId: string): boolean {
        return (this.selected?.viewer_ids || []).includes(userId);
    }

    public toggleUser(userId: string, event: any) {
        if (!this.selected.viewer_ids) this.selected.viewer_ids = [];
        const checked = !!event.target.checked;
        const idx = this.selected.viewer_ids.indexOf(userId);
        if (checked && idx < 0) this.selected.viewer_ids.push(userId);
        if (!checked && idx >= 0) this.selected.viewer_ids.splice(idx, 1);
    }

    public selectAllUsers() {
        this.selected.viewer_ids = this.users.map((u: any) => u.id);
        this.service.render();
    }

    public clearUsers() {
        this.selected.viewer_ids = [];
        this.service.render();
    }

    public saveData(): any {
        return {
            id: this.selected.id || '',
            subject: this.selected.subject || '',
            category: this.selected.category || 'other',
            reply_type: this.selected.reply_type || 'not_required',
            received_date: this.selected.received_date || this.today(),
            sender: this.selected.sender || '',
            document_no: this.selected.document_no || '',
            content: this.selected.content || '',
            attachments: JSON.stringify(this.selected.attachments || []),
            viewer_ids: JSON.stringify(this.selected.viewer_ids || [])
        };
    }

    public async save(silent: boolean = false) {
        if (!this.selected.subject?.trim()) {
            this.service.alert.error("제목을 입력해주세요.");
            return;
        }
        const { code, data } = await wiz.call("save", this.saveData());
        if (code === 200) {
            this.selected.id = data.id;
            if (!silent) this.service.alert.success("동의서/공문 접수가 저장되었습니다.");
            if (!silent) {
                await this.load(this.search.page || 1);
                const current = this.items.find((item: any) => item.id === data.id);
                if (current) await this.open(current);
            }
        } else {
            this.service.alert.error(data?.message || "저장에 실패했습니다.");
        }
    }

    public async deleteSelected() {
        if (!this.selected?.id) return;
        const ok = await this.service.alert.show({
            title: '삭제',
            message: '동의서/공문 접수 문서를 삭제하시겠습니까?',
            action: '삭제',
            actionBtn: 'error',
            status: 'error'
        });
        if (!ok) return;
        const { code, data } = await wiz.call("delete", { id: this.selected.id });
        if (code === 200) {
            this.service.alert.success("삭제되었습니다.");
            await this.load(1);
            this.newReceipt();
        } else {
            this.service.alert.error(data?.message || "삭제에 실패했습니다.");
        }
    }

    public async onFileSelect(event: any) {
        const files = event.target.files;
        if (!files || files.length === 0) return;

        if (!this.selected.id) {
            await this.save(true);
            if (!this.selected.id) return;
        }

        for (let i = 0; i < files.length; i++) {
            const formData = new FormData();
            formData.append('file', files[i]);
            formData.append('approval_id', this.selected.id);
            const response = await fetch(`/wiz/api/${wiz.namespace}/upload`, {
                method: 'POST',
                body: formData
            });
            const result = await response.json();
            if (result.code === 200) {
                if (!this.selected.attachments) this.selected.attachments = [];
                this.selected.attachments.push(result.data.file);
            }
        }
        event.target.value = '';
        await this.save(true);
        await this.service.render();
    }

    public async removeAttachment(index: number) {
        const file = this.selected.attachments[index];
        if (!file) return;
        await wiz.call("remove_file", {
            approval_id: this.selected.id,
            stored_name: file.stored_name
        });
        this.selected.attachments.splice(index, 1);
        await this.save(true);
    }

    public downloadAttachment(file: any) {
        const url = `/wiz/api/${wiz.namespace}/download?approval_id=${this.selected.id}&stored_name=${encodeURIComponent(file.stored_name)}&original_name=${encodeURIComponent(file.original_name)}`;
        window.open(url, '_blank');
    }

    public formatFileSize(bytes: number): string {
        if (!bytes) return '0B';
        if (bytes < 1024) return bytes + 'B';
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + 'KB';
        return (bytes / (1024 * 1024)).toFixed(1) + 'MB';
    }
}

export default PortalLpsysadminOfficialReceiptComponent;